export default __webpack_public_path__ + "static/media/Stephanie_9781408308196.062cc764.jpg";